import React from 'react';
import { createRoot } from 'react-dom/client';
import { connect } from 'react-redux';

import ThreeDotsButton from 'common/components/ThreeDotsButton';
import readAttribute from 'common/tools/dom/readAttribute';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';
import { ReduxUser } from 'common/types';

import { HoverTooltip } from 'website/components/Tooltip';
import allocineContainer from 'website/containers/allocineContainer';
import { openShareModal } from 'website/services/modal';

type Props = {
  user: ReduxUser;
  profileUserId?: string;
};
const UserCoverMenu = ({ profileUserId, user }: Props) => {
  // Not rendering anything until we know there is a connected user
  // and he's looking at his own profile page
  if (
    !user.passiveLoginDone ||
    !user.loggedIn ||
    user.account?.id !== profileUserId
  )
    return null;

  const buttons = (
    <>
      <a
        className="icon icon-share"
        onClick={e => {
          e.preventDefault();
          openShareModal({
            url: path('userprofile_index', { user: user.account?.id }, true),
            title: trans('userspace.share.my-profile')
          });
        }}
      >
        {trans('userspace.share.my-profile')}
      </a>
      <a
        className="icon icon-mac-settings"
        href={path('userspace_settings_profile', {}, true)}
      >
        {trans('userprofile.user-cover.settings.label')}
      </a>
    </>
  );

  return (
    <HoverTooltip
      tooltipContent={buttons}
      position="bottom"
      className="tooltip-menu"
    >
      <ThreeDotsButton />
    </HoverTooltip>
  );
};

export { UserCoverMenu as UserCoverMenuForTests };

export default () => {
  const ConnectedUserCoverMenu = allocineContainer(
    connect((state: { user: ReduxUser }) => ({ user: state.user }))(
      UserCoverMenu
    )
  );

  const anchors = document.getElementsByClassName('js-user-cover-menu');

  for (const anchor of anchors) {
    const userId = readAttribute<string, undefined>(anchor, 'data-user-id');
    const root = createRoot(anchor);
    root.render(<ConnectedUserCoverMenu profileUserId={userId} />);
  }
};
